import React from 'react';

interface SectionProps {
  id: string;
  title?: string;
  children: React.ReactNode;
  className?: string;
  titleClassName?: string;
  contentClassName?: string;
  titleAccent?: string;
}

const Section: React.FC<SectionProps> = ({ 
  id, 
  title, 
  children, 
  className = '', 
  titleClassName = '', 
  contentClassName = '',
  titleAccent = 'text-emerald-600' 
}) => {
  return (
    <section id={id} className={`py-16 md:py-24 ${className}`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {title && (
          <div className="text-center mb-12 md:mb-16">
            <h2 className={`text-3xl md:text-4xl lg:text-5xl font-bold ${titleAccent} ${titleClassName}`}>
              {title}
            </h2>
          </div>
        )}
        <div className={contentClassName}>
          {children}
        </div>
      </div>
    </section>
  );
};

export default Section;
